module.exports = __webpack_public_path__ + "static/media/process_1.9277f6d8.png";